<template>
  <v-dialog v-model="isOpen" max-width="600">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn icon v-on="{...tooltip, ...dialog}">
            <v-icon>
              {{ downloadIcon }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $vuetify.lang.t('$vuetify.map.driverTrips.actions.stats') }}</span>
      </v-tooltip>
    </template>

    <v-card>

      <v-toolbar>
        <v-icon left>{{ downloadIcon }}</v-icon>
        <v-toolbar-title>{{ $vuetify.lang.t('$vuetify.map.tripDownload.title') }}</v-toolbar-title>

        <v-progress-linear :active="isLoading" indeterminate absolute bottom>
        </v-progress-linear>

        <v-spacer></v-spacer>

        <v-btn icon @click="isOpen = false">
          <v-icon>{{ closingIcon }}</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form>
          <v-radio-group v-model="type" row :label="$vuetify.lang.t('$vuetify.map.tripDownload.statisticsType.title')"
                         mandatory>
            <v-radio value="pure">
              <template v-slot:label>
                <v-icon left>{{ pureIcon }}</v-icon>
                {{ $vuetify.lang.t('$vuetify.map.tripDownload.statisticsType.pure') }}
              </template>
            </v-radio>
            <v-radio value="critical" v-if="criticalEventsCount > 0">
              <template v-slot:label>
                <v-icon left>{{ criticalIcon }}</v-icon>
                {{ $vuetify.lang.t('$vuetify.map.tripDownload.statisticsType.critical') }}
              </template>
            </v-radio>
          </v-radio-group>
          <v-select v-model="format" :items="items" item-text="text" item-value="value"
                    :label="$vuetify.lang.t('$vuetify.map.tripDownload.formatType.title')">
            <template v-slot:selection="{ item, index }">
              <v-icon left>{{ item.icon }}</v-icon>
              {{ item.text }}
            </template>
            <template v-slot:item="{ item }">
              <v-icon left>{{ item.icon }}</v-icon>
              {{ item.text }}
            </template>
          </v-select>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="loadStatistics" :disabled="isLoading">
          {{ $vuetify.lang.t('$vuetify.map.tripDownload.download') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mdiClose,
  mdiFileDelimited,
  mdiFileDownload,
  mdiMapMarkerAlert,
  mdiMapMarkerDistance
} from '@mdi/js'

import backend from '../../../backend'
import snackbarMixin from '../../../mixins/snackbarMixin'

export default {
  name: 'tripDownload',
  props: {
    userId: Number,
    dateStart: Number,
    criticalEventsCount: Number
  },
  mixins: [snackbarMixin],
  data: () => ({
    isOpen: false,
    type: null,
    format: 'csv', // { value: 'csv', text: 'CSV', icon: mdiFileDelimited },
    items: [
      { value: 'csv', text: 'CSV', icon: mdiFileDelimited }
      // { value: 'excel', text: 'Excel', icon: mdiFileExcel }
    ],
    isLoading: false,

    downloadIcon: mdiFileDownload,
    pureIcon: mdiMapMarkerDistance,
    criticalIcon: mdiMapMarkerAlert,
    closingIcon: mdiClose
  }),
  methods: {
    async loadStatistics () {
      const siteUrl = `${
        process.env.VUE_APP_SITE !== undefined
          ? process.env.VUE_APP_SITE
          : '/api/v2/'
      }`

      this.isLoading = true

      try {
        const result = await backend.downloadTripStatistics({
          user_id: this.userId,
          date_start: this.dateStart,
          type: this.type,
          format: this.format,
          lang: this.$vuetify.lang.current
        })

        const url = window.URL.createObjectURL(new Blob([result.data], { type: result.headers['content-type'] }))
        const link = document.createElement('a')
        link.href = url

        link.setAttribute('download', result.headers.filename)
        link.click()
        window.URL.revokeObjectURL(url)
      } catch (e) {
        this.processFailedRequest(e)
      } finally {
        this.isLoading = false
        this.isOpen = false
      }
    }
  }
}
</script>

<style scoped>

</style>
